<template>
 <div>
    <loader :show="enviando"/>
    <b-modal  v-model="mostrar" size="xl" title="Acta" hide-footer  hide-header-close no-close-on-backdrop>   
    <b-card-body>
    <b-row>
      
      
       <b-col md="4">
        <b-form-group >
          <label>No. Cuenta</label>
          <b-form-input           
            v-model="cuenta.noCuenta"
            disabled            
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group >
          <label>Fecha</label>
          <b-form-input           
            v-model="fecha"
            type="date"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
     <b-col md="4">
        <b-form-group >
          <label>Folio de acta</label>
          <b-form-input           
            v-model="acta.folio"
            placeholder="Ingresar folio de acta"
            :class="{invalid_input: $v.acta.folio.$error}"           
          ></b-form-input>
          <label v-if="$v.acta.folio.$error && !$v.acta.folio.required" class="error-text" >
            <i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group >
          <label>Razón social</label>
          <b-form-input           
            v-model="cuenta.razonSocial"
            disabled
            
          ></b-form-input>
          
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group >
          <label>Código Postal</label>
          <b-form-input           
            v-model="cuenta.cp"
            disabled
            
          ></b-form-input>
          
        </b-form-group>
      </b-col>
     <b-col md="4">
        <b-form-group >
          <label>Colonia</label>
          <b-form-input           
            v-model="cuenta.colonia"
            disabled            
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group >
          <label>Domicilio</label>
          <b-form-input           
            v-model="cuenta.domicilio"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
     
      <b-col md="4">
        <b-form-group >
          <label>Delegación</label>
          <b-form-input           
            v-model="cuenta.delegacion"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group >
          <label >Giro</label>
          <b-form-input           
            v-model="cuenta.giro"
           disabled
          ></b-form-input>
          
        </b-form-group>
      </b-col>
       <b-col md="6">
        <b-form-group >
          <label >Giro de uso de suelo</label>
          <b-form-input           
            v-model="acta.giroSuelo"
            :class="{invalid_input: $v.acta.giroSuelo.$error}"
            placeholder="Giro "
          ></b-form-input>
          <label v-if="$v.acta.giroSuelo.$error && !$v.acta.giroSuelo.required" class="error-text" >
            <i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
       <b-col md="8">
        <b-form-group >
          <label >Nombre de quién recibe inspección</label>
          <b-form-input           
            v-model="acta.nombreInspeccion"
            :class="{invalid_input: $v.acta.nombreInspeccion.$error}"
            placeholder="Nombre(s) Paterno Materno"
          ></b-form-input>
          <label v-if="$v.acta.nombreInspeccion.$error && !$v.acta.nombreInspeccion.required" class="error-text" >
            <i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
       <b-col md="4">
        <b-form-group >
          <label>Tipo de identificación</label>
          <b-form-select v-model="acta.identificacion" :options="identificaciones" class="mb-3"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group >
          <label >No. Identificación</label>
          <b-form-input           
            v-model="acta.noIdentificacion"
            :class="{invalid_input: $v.acta.noIdentificacion.$error}"
            placeholder="No. identificación"
          ></b-form-input>
          <label v-if="$v.acta.noIdentificacion.$error && !$v.acta.noIdentificacion.required" class="error-text" >
            <i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group >
          <label >Puesto</label>
          <b-form-input           
            v-model="acta.puesto"
            :class="{invalid_input: $v.acta.puesto.$error}"
            placeholder="Puesto"
          ></b-form-input>
          <label v-if="$v.acta.puesto.$error && !$v.acta.puesto.required" class="error-text" >
            <i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <label >Observaciones</label>
          <b-form-textarea
            v-model="acta.observaciones"
            placeholder="Observaciones"
            maxlength=500
          ></b-form-textarea>
      </b-col>
    </b-row>
         <br />
     <b-list-group sm="12">
        <b-list-group-item v-for="testigo, index in testigos" :key="index">
          
          <b-row >
            <b-col md="11" >
            <h4 style="text-align: center" >T E S T I G O </h4>
            </b-col>
            <b-col md="1" >
            <b-button  variant="danger" size="sm" @click="eliminaTestigo(index)">x </b-button>
            </b-col>
           </b-row>
          
          <b-col md="12">
            <b-row>
              <b-col md="8">
              <b-form-group >
                <label >Nombre del testigo</label>
                <b-form-input           
                  v-model="testigo.nombre"
                  placeholder="Nombre(s) Paterno Materno"
                  :class="{invalid_input: $v.testigos.$each[index].nombre.$error}"
                    
                ></b-form-input>
                <label v-if="$v.testigos.$each[index].nombre.$error && !$v.testigos.$each[index].nombre.required" class="error-text" >
                  <i>Campo requerido.</i></label>
              </b-form-group>
            </b-col>
                   <b-col md="4">
              <b-form-group >
                <label>Tipo de identificación</label>
                <b-form-select v-model="testigo.identificacion" :options="identificaciones" class="mb-3"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group >
                <label >No. Identificación</label>
                <b-form-input           
                  v-model="testigo.noIdentificacion"
                  placeholder="No. identificación"
                  :class="{invalid_input: $v.testigos.$each[index].noIdentificacion.$error}"
                ></b-form-input>
                <label v-if="$v.testigos.$each[index].noIdentificacion.$error && !$v.testigos.$each[index].noIdentificacion.required" class="error-text" >
                  <i>Campo requerido.</i></label>
              </b-form-group>
            </b-col>
            <b-col md="6">
            <b-form-group >
              <label >Puesto</label>
              <b-form-input           
                v-model="testigo.puesto"
                placeholder="Puesto"
                :class="{invalid_input: $v.testigos.$each[index].puesto.$error}"
              ></b-form-input>
             <label v-if="$v.testigos.$each[index].puesto.$error && !$v.testigos.$each[index].puesto.required" class="error-text" >
                <i>Campo requerido.</i></label>
            </b-form-group>
          </b-col>
     
              
            </b-row>
          </b-col>
        </b-list-group-item>
     </b-list-group>
     <br />
    <b-row>
      <b-col md="12">
        <b-button  variant="primary" size="sm" @click="nuevoTestigo()">Agregar Testigo</b-button>
      </b-col>
    </b-row>
    <br />
    <b-row v-if="recomendaciones.length>0"> 
      <b-col>
      <h4 style="text-align: center" >R E C O M E N D A C I O N E S</h4>
      </b-col>
    </b-row>
    <b-list-group sm=12>
    <b-list-group-item v-for="recomendacion, index in recomendaciones" :key="index">      

      <b-input-group  class="mt-3">
        <b-form-textarea :class="{invalid_input: $v.recomendaciones.$each[index].texto.$error}"
            v-model="recomendacion.texto" placeholder="Observaciones"  maxlength=150
        ></b-form-textarea>

        <b-input-group-append>
          <b-button  variant="danger" size="sm" @click="eliminaRecomendacion(index)"> x </b-button>
        </b-input-group-append>
      </b-input-group> 
         <label v-if="$v.recomendaciones.$each[index].texto.$error && !$v.recomendaciones.$each[index].texto.required" class="error-text" >
          <i>Campo requerido.</i></label>
    </b-list-group-item> 
    </b-list-group>
    
    <br />

    <b-row>
      <b-col md="12">
        <b-button  variant="primary" size="sm" @click="nuevaRecomendacion()">Agregar Recomendación</b-button>
      </b-col>
    </b-row>
    <br />

    <b-row>      
      <b-col style="text-align: center">
        <b-button @click="$emit('cancelar')" :disabled="enviando">Cancelar</b-button>
        <br />
      </b-col>
      <b-col style="text-align: center">
        <b-button variant="primary" @click="guardar()" :disabled="enviando">Guardar cambios</b-button>
      </b-col>
     
    </b-row>
    </b-card-body>
    </b-modal>

  </div>
</template>

<script>
import axios from "axios";
import Loader from "../Loader";
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
const { DateTime } = require("luxon");

export default {
  name: "Agregar-acta",
  components: { Loader },
  props: ["mostrar", "editarActa", "cuenta", 'idExpediente'],
  computed: { ...mapGetters(["httpURL", "sessionToken"])},
  validations: {
    acta:{    
      folio: {required},
      giroSuelo:{ required },
      nombreInspeccion:{ required },
      noIdentificacion:{ required },
      puesto:{ required },

    },
    testigos:{
      $each:{
      nombre: {required},
      noIdentificacion : {required},
      puesto:{required},
      }

    },
    recomendaciones:{
      $each: {texto: {required} }
    }
    
  },
  data: function() {
    return {
      enviando: false,    
      fecha: DateTime.now().toFormat('yyyy-MM-dd'),
      acta:{
        tipoSolicitud:null,
        folio:null,
        giroSuelo:null,
        nombreInspeccion:null,
        identificacion:null,
        noIdentificacion:null,
        puesto:null,
        recomendaciones:[],
        observaciones:null,
       
      },
      recomendaciones:[],
      identificaciones:['INE', 'Pasaporte', 'Licencia de conducir'],
     
      testigos:[]
    };
  },
  mounted(){
     if(this.editarActa){
      this.acta =  {
        
        folio:this.editarActa.folio,
        fecha : DateTime.fromISO(this.editarActa.fecha).toFormat('yyyy-MM-dd'),
        giroSuelo: this.editarActa.giroSuelo,
        nombreInspeccion : this.editarActa.inspeccion.nombre,
        identificacion:this.editarActa.inspeccion.identificacion,
        noIdentificacion:this.editarActa.inspeccion.noIdentificacion,
        puesto:this.editarActa.inspeccion.puesto,
        recomendaciones: this.editarActa.recomendaciones,
        observaciones:this.editarActa.observaciones
      
      }
      if(this.editarActa.recomendaciones.length>0){
        this.editarActa.recomendaciones.forEach(rec=>{
          this.recomendaciones.push({texto: rec})
        })
      }
      if(this.editarActa.testigos.length>0){
        this.editarActa.testigos.forEach(test=>{
          let testigo = {
          nombre:test.nombre,
          identificacion:test.identificacion,
          noIdentificacion:test.noIdentificacion,
          puesto:test.puesto
        }
        this.testigos.push(testigo)
        })
      }
      
     }
     else{
      this.acta.identificacion=this.identificaciones[0];
      
     }
  },  
  methods: {  
     nuevoTestigo(){
      let testigo = {
        nombre:null,
        identificacion:this.identificaciones[0],
        noIdentificacion:null,
        puesto:null,
      }
      this.testigos.push(testigo)
    },
    nuevaRecomendacion(){
      let recomendacion = {texto:null};
      this.recomendaciones.push(recomendacion)
    },
    eliminaRecomendacion(index){
      this.recomendaciones.splice(index,1)
    },
    eliminaTestigo(index){
      this.testigos.splice(index, 1);
      //this.contador--;
    },
  
    guardar(){
        this.$v.$touch();
        
        if (!this.$v.$invalid) {
         
          this.enviando=true;
          let listaRecomendaciones = this.recomendaciones.map(x=>{return x.texto})
          let actaNueva = { ...this.acta, testigos:this.testigos, recomendaciones:listaRecomendaciones, cuenta:this.cuenta._id}
          
          if(!this.editarActa){
          axios.post(this.httpURL+'/proteccionBomberos/expediente/'+this.idExpediente+'/acta',
              actaNueva,
              {headers: {token:this.sessionToken}})
          .then(res => {
            console.log(res.data);
              this.enviando=false;
              if(res.data.ok){
              this.$emit('guardar',res.data.acta);
              this.$emit('cancelar');
              this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000, text: res.data.mensaje })
              }
          })
          .catch(error => {
            //console.log(error);
              this.enviando=false;
              if(error.response){
                  //console.log(error.response);
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000, text: error.response.data.mensaje });
              }else if( error.request){
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000, text: 'No se pudo establecer una conexión al servidor.' });
              }
          });
          }
          else{
            
             axios.put(this.httpURL+'/proteccionBomberos/expediente/acta/'+this.editarActa._id,
              actaNueva,
              {headers: {token:this.sessionToken}})
              .then(res => {
           // console.log(res.data);
              this.enviando=false;
              if(res.data.ok){
              this.$emit('actualizar',res.data.acta);
              this.$emit('cancelar');
              this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000, text: res.data.mensaje })
              }
          })
          .catch(error => {
            //console.log(error);
              this.enviando=false;
              if(error.response){
                  //console.log(error.response);
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000, text: error.response.data.mensaje });
              }else if( error.request){
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000, text: 'No se pudo establecer una conexión al servidor.' });
              }
          });
          }
        
      }

    },
   
   
  }
};
</script>

<style >
.error-text {
  color: #ff0000;
}
.invalid_input{
    border: 1px solid red;
}

</style>
